import Link from 'next/link';
import React from 'react';
import { StrapiImageComponent } from '../../util/MediaComponent/MediaComponent';
import styles from './resourceComponent.module.scss';
import { StrapiImage } from '../../Models/MediaProps';
import { ResourceCategory } from '../../Models/ResourceProps';

type ResourceProps = {
    mainImage?: StrapiImage;
    heading: string;
    ingress: string;
    seoUrl: string;
    authorName: string;
    publishedAt: string;
    resource_category: ResourceCategory;
    linearLayout?: boolean;
    isShowAuthor?: boolean;
};
type GetAuthorTextProps = {
    authorName: string;
    publishedAt: string;
};

export const getMonthName = (monthNumber: number) => {
    switch (monthNumber) {
        case 1:
            return 'January';
        case 2:
            return 'February';
        case 3:
            return 'March';
        case 4:
            return 'April';
        case 5:
            return 'May';
        case 6:
            return 'June';
        case 7:
            return 'July';
        case 8:
            return 'August';
        case 9:
            return 'September';
        case 10:
            return 'October';
        case 11:
            return 'November';
        case 12:
            return 'December';
        default:
            return '';
    }
};

const getDateAsString = (dateString = '') => {
    var date = new Date(dateString);
    const year = date.getFullYear().toString();
    const month = getMonthName(date.getMonth() + 1);
    const day = date.getDate().toString();
    return `${day}. ${month} ${year}`;
};

export const GetAuthorText = ({ authorName, publishedAt }: GetAuthorTextProps) => (
    <p className={styles.author}>
        {authorName && <span>By: {authorName}, </span>}
        {getDateAsString(publishedAt)}
    </p>
);

const ResourceComponent = ({
    mainImage,
    heading,
    ingress,
    seoUrl,
    publishedAt,
    authorName,
    resource_category,
    linearLayout,
    isShowAuthor = true,
}: ResourceProps) => (
    <div className={styles.resourceContainer} data-category={resource_category?.name}>
        <Link href={`/resources/${seoUrl}`} title={`Go to resource page for ${heading}`}>
            <div className={styles.img_hover_zoom}>
                <StrapiImageComponent maxWidth={772} maxHeight={435} strapiImage={mainImage} />
            </div>
            {heading && <p className={styles.heading}>{heading}</p>}
            {ingress && <h2 className={styles.description}>{ingress}</h2>}
        </Link>
        {isShowAuthor ? <GetAuthorText authorName={authorName} publishedAt={publishedAt} /> : null}
    </div>
);

export default ResourceComponent;
